import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import rolesPlugin from './plugins/rolesPlugin'
import axios from 'axios'
import JsonExcel from 'vue-json-excel'
import excel from 'vue-excel-export'
import { GChart } from 'vue-google-charts/legacy'
import VueApexCharts from 'vue-apexcharts'
import VueGtag from "vue-gtag";
import VueImg from 'v-img';
//funciones personalizadas
import {formatoFechaSpanish, formatoFecha, formatoFechaHoras, formatoNumero,formatoNumeroPorcentaje, obtenerIndicePorID,esNulo, quitarFormatoNumero, verificarRol, verificarAlgunRol, obtenerRolPrincipal, obtenerRolesActivos} from './plugins/genericas.js'

Vue.use(VueApexCharts)
Vue.use(VueGtag, {
  config: { 
    id: 'UA-54802013-3' 
    //id: 'G-C0DS104EEC'
  } 
});
Vue.use(excel);
Vue.use(GChart);
Vue.use(VueImg);
Vue.use(rolesPlugin);

Vue.prototype.$formatoFechaSpanish = formatoFechaSpanish;
Vue.prototype.$formatoFecha = formatoFecha;
Vue.prototype.$formatoFechaHoras = formatoFechaHoras;
Vue.prototype.$formatoNumero = formatoNumero;
Vue.prototype.$formatoNumeroPorcentaje = formatoNumeroPorcentaje;
Vue.prototype.$quitarFormatoNumero = quitarFormatoNumero;
Vue.prototype.$obtenerIndicePorID = obtenerIndicePorID;
Vue.prototype.$esNulo = esNulo;
Vue.prototype.$verificarRol = verificarRol;
Vue.prototype.$verificarAlgunRol = verificarAlgunRol;
Vue.prototype.$obtenerRolPrincipal = obtenerRolPrincipal;
Vue.prototype.$obtenerRolesActivos = obtenerRolesActivos;

Vue.config.productionTip = false
//axios.defaults.baseURL=""
axios.defaults.baseURL=""

console.log("hostname: ",window.location.hostname);
const baseURLs = {
  'presupuesto.megapps.com.bo': 'https://presupuesto.megapps.com.bo/',  
  'localhost': 'https://localhost:44325/'
};

const hostname = window.location.hostname;
axios.defaults.baseURL = baseURLs[hostname] || 'https://localhost:44325/';

Vue.component("downloadExcel", JsonExcel);
Vue.component('apexchart', VueApexCharts)

// Configurar interceptor de Axios para agregar token a las peticiones
axios.interceptors.request.use(
  (config) => {
    const token = store.state.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta para manejar errores de autenticación
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expirado o inválido
      store.dispatch('salir');
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')

//gtag('set', 'page', router.currentRoute.path);
//gtag('send', 'pageview');

//router.afterEach(( to, from ) => {
//  gtag('set', 'page', to.path);
//  gtag('send', 'pageview');
//});

export const globalStore = new Vue({
  data: {
    globalvar: 'global hello world'
  }
})





